import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

export const Root = styled.main`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background-color: #f5f5f5;
`

export const Card = styled.section`
  max-width: 620px;
  width: 100%;
  background-color: #fff;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
`

export const Label = styled.p`
  margin-bottom: 8px;
  font-size: 14px;
  color: #7a7a7a;
`

export const ErrorCodeText = styled.p`
  margin: 0;
  font-size: 54px;
  font-weight: 600;
  color: #0f172a;
`

export const Description = styled.p`
  margin-top: 16px;
  font-size: 16px;
  color: #334155;
`

export const HomeLink = styled(Link)`
  display: inline-flex;
  margin-top: 24px;
  padding: 12px 24px;
  border-radius: 8px;
  background-color: #2563eb;
  color: #fff;
  text-decoration: none;
  font-weight: 500;
`
